import React from "react";

import { siteLocationPrefix, ticketingLocationPrefix } from "../../constants";
import { Programs } from "../../models/programsConfig";
import { TestButton } from "./TestButton";
import * as styles from "./TestStyle.module.css";

export const TestOtherFeaturesActions = () => (
  <div className={styles.pcEnrollmentActionsWrapper}>
    <h3>Other Features</h3>
    <TestButton
      type={Programs.IdXbox}
      url={`/games/support/request-gdkx-middleware`}
      title="GDK Middleware Request Site"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/activision-blizzard-cloud-game-streaming-eu/streaming-provider-registration`}
      title="EU Streaming Provider Registration Site"
    />
    <TestButton type={Programs.IdXbox} url={ticketingLocationPrefix} title="Ticketing" />
    <br />
    <br />
  </div>
);
